define("settings/routes/overview/password", ["exports", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/routing/route", "@ember/service", "ember-concurrency", "later/utils/fetch", "settings/utils/handle-settings-error"], function (_exports, _asyncArrowRuntime, _object, _route, _service, _emberConcurrency, _fetch, _handleSettingsError) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"@ember/object",0,"@ember/routing/route",0,"@ember/service",0,"ember-concurrency",0,"later/utils/fetch",0,"settings/utils/handle-settings-error"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  let PasswordRoute = _exports.default = (_class = class PasswordRoute extends _route.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "auth", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "router", _descriptor4, this);
      _initializerDefineProperty(this, "settings", _descriptor5, this);
      _defineProperty(this, "passwordDetails", {
        currentPassword: null,
        newPassword: null,
        newPasswordConfirmation: null
      });
      _defineProperty(this, "handleClose", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function (_ref) {
          var _this = this;
          let {
            newPassword,
            newPasswordConfirmation,
            currentPassword
          } = _ref;
          return function* () {
            const condition = newPassword || newPasswordConfirmation || currentPassword;
            yield _this.settings.confirmClose(condition);
            _this._resetPasswordDetails();
            _this.router.transitionTo('account.overview');
          }();
        }
      }), null, "handleClose", null));
      _defineProperty(this, "handleSubmit", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function (user, _ref2) {
          var _this2 = this;
          let {
            newPassword,
            newPasswordConfirmation,
            currentPassword
          } = _ref2;
          return function* () {
            try {
              if (newPassword !== newPasswordConfirmation) {
                throw (0, _handleSettingsError.default)(_this2.intl.t('account.overview.password.error.message_mismatch'), 'account.overview.password', _this2.intl);
              }
              const request = (0, _fetch.fetch)('/api/v2/update_password.json', {
                method: 'PATCH',
                headers: {
                  'Content-type': 'application/json'
                },
                body: JSON.stringify({
                  user: {
                    id: user.id,
                    current_password: currentPassword,
                    password: newPassword,
                    password_confirmation: newPasswordConfirmation
                  }
                })
              });
              const {
                alert
              } = yield _this2.settings.submitForm.perform(request, 'account.overview.password');
              if (alert) {
                _this2.alerts.add(alert);
              }
              _this2.handleClose.perform(_this2._resetPasswordDetails());
            } catch ({
              alert
            }) {
              if (alert) {
                _this2.alerts.add(alert);
              }
            }
          }();
        }
      }), null, "handleSubmit", null));
    }
    model() {
      return this.auth.currentUserModel;
    }
    setupController(controller, model) {
      controller.setProperties({
        user: model,
        passwordDetails: _object.default.create(this.passwordDetails),
        handleClose: this.handleClose,
        handleSubmit: this.handleSubmit
      });
    }
    _resetPasswordDetails() {
      return this.controller.set('passwordDetails', _object.default.create(this.passwordDetails));
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "settings", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
});